<template>
  <v-layout v-if="announcement" :class="['announcement-main', isWarningAnnouncement && 'announcement-main--warning']" row>
    <v-flex class="announcement-main__icon">
      <i class="material-icons">campaign</i>
    </v-flex>
    <v-flex class="announcement-main__details">
      <div class="announcement-main__details--header">{{ announcement.title }}</div>
      <div class="announcement-main__details--full-desc" v-if="isFullView">
        <div class="pt-2" v-html="announcement.longDescription"></div>
      </div>
      <div class="announcement-main__details--desc" v-else>{{ announcement.shortDescription }}</div>
      <div class="announcement-main__details--button">
        <v-btn class="read-more-btn" @click="handleActionButtonClick(announcement)">{{ actionButtonText }}</v-btn>
      </div>
    </v-flex>
    <v-flex class="text-right">
      <v-btn class="announcement-close-icon" flat icon size="16" @click="handleClose(announcement.id)">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { chapterStudioPageConstant } from "./chapterStudioPage.constant";

export default {
  name: 'GeneralAnnouncementCard',
  data() {
    return {
      chapterStudioPageConstant,
    };
  },
  props: {
    announcement: {
      type: Object,
      require: true,
    },
    isWarningAnnouncement: {
      type: Boolean,
      default: false,
    },
    isFullView: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onActionButtonClick: {
      type: Function,
      required: true,
    },
    actionButtonText: {
      type: String,
      required: true,
    },
  },
  computed: {
    announcementTitle() {
      return this.isWarningAnnouncement
          ? chapterStudioPageConstant.ANNOUNCEMENT_TITLE_WARNING
          : chapterStudioPageConstant.ANNOUNCEMENT_TITLE_GENERAL;
    },
  },
  methods: {
    handleClose(announcementId) {
      this.onClose(announcementId);
    },
    handleActionButtonClick(announcement) {
      this.onActionButtonClick(announcement);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.announcement-main {
  background-color: $white;
  border-radius: 8px;
  border: 2px solid $ypo-brand-blue;
  padding: 10px 5px 10px 10px;

  @include breakpointMin(sm) {
    padding: 15px;
  }

  &__icon {
    width: 25px;
    max-width: 25px;
    color: $ypo-brand-blue;
  }

  &__details {
    padding-left: 15px;
    padding-top: 1px;

    &--header {
      font-size: 16px;
      line-height: 22.4px;
      font-weight: 600;
      color: $ypo-brand-blue;
    }

    &--desc {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      letter-spacing: 0.9px;
      padding-top: 3px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* number of lines to show */
      line-clamp: 2;

      @include breakpointMin(sm) {
        -webkit-line-clamp: 1; /* number of lines to show */
        line-clamp: 1;
      }
    }

    &--button {
      padding-top: 12px;

      .read-more-btn {
        margin: 0;
        height: 30px;
        width: 99px;
        font-size: 12px;
        font-weight: 600;
        border-radius: 8px;
        color: $white;
        background-color: $ypo-brand-blue !important;
      }
    }
  }

  .announcement-close-icon {
    color: $ypo-brand-blue;
    margin: 0;
    position: relative;
    right: -8px;
    top: -10px;

    .v-icon {
      font-size: 18px;
    }
  }
}

.announcement-main--warning {
  border: 2px solid $ypo-error-red;
  background-color: $ypo-red-faded;

  .announcement-main {
    &__icon {
      color: $ypo-error-red;
    }

    &__details {
      &--header {
        color: $ypo-error-red;
      }

      &--button {
        .read-more-btn {
          background-color: $ypo-error-red !important;
        }
      }
    }
  }

  .announcement-close-icon {
    color: $ypo-error-red;
  }
}
</style>

